import React from 'react'
import loader from "../assets/img/loader.gif";
export function Loader() {
    return (
        <div className="loader">
            <img src={loader} alt="" />
        </div>
    )
}
